/**
 * Ranking screens — small interactive helpers.
 *
 * page-ranking-teams: animate horizontal bars from width 0 to their target.
 * Target value is set via inline style `--target-width: NN%` from Twig.
 */

function animateTeamBars() {
    const bars = document.querySelectorAll('.s-ranking-teams__bar');
    if (bars.length === 0) return;

    requestAnimationFrame(() => {
        bars.forEach((el) => {
            const target = el.style.getPropertyValue('--target-width').trim();
            if (target) {
                el.style.width = target;
            }
        });
    });
}

function init() {
    if (document.body.classList.contains('page-ranking-teams')) {
        animateTeamBars();
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
